module.exports = __webpack_public_path__ + "assets/discount_orange-da17b0.svg";